// extracted by mini-css-extract-plugin
export default {"Container":"Escalera_Container__NPnom","EscaleraContainer":"Escalera_EscaleraContainer__thmUs","SeparatorEscImg":"Escalera_SeparatorEscImg__+YcjE"};